<template>
  <div
    @click="selectItem(currentLayer)"
    class="selectableItem"
    :class="{ selectedToolItem: objectTypeIsSelected }"
    @contextmenu.prevent="toggleOptionsMenu(objectType)"
  >
    <component
      :is="objectTypeIsSelected ? currentLayer.filledIcon : currentLayer.icon"
      class="toolsSVG"
      :class="{ filled: objectTypeIsSelected }"
    />

    <v-icon
      size="16"
      :color="objectTypeIsSelected ? 'accent' : 'primary'"
      class="options-arrow"
    >
      {{ listIsOpen ? "arrow_drop_up" : "arrow_drop_down" }}
    </v-icon>

    <span class="svgTextToolbar">{{ label }}</span>

    <instructions-tooltip
      v-if="currentLayer.instructions && objectTypeIsSelected"
      :icon="currentLayer.filledIcon"
      :instructions="currentLayer.instructions"
    />

    <item-options-menu
      :is-open="listIsOpen"
      :options="options"
      :current-layer="currentLayer.layer"
      @select="activateLayer"
    />
  </div>
</template>

<script>
import ItemOptionsMenu from "@/components/Home/Toolbars/CreateObjects/ItemOptionsMenu";
import { mapActions } from "vuex";
import InstructionsTooltip from "@/components/Home/Toolbars/CreateObjects/InstructionsTooltip";

export default {
  name: "CreateObjectsToolbarItemWithOptions",

  components: { ItemOptionsMenu, InstructionsTooltip },

  props: {
    label: {
      type: String,
      required: true
    },

    objectType: {
      type: String,
      required: true
    },

    defaultLayer: {
      type: String,
      required: true
    },

    options: {
      type: Array,
      required: true
    },

    openList: {
      type: String | null,
      required: true
    }
  },

  data() {
    return {
      currentLayer: null
    };
  },

  computed: {
    selectedObjectLayer() {
      return this.$store.getters.tools_selectedObjectLayer;
    },

    selectedObjectType() {
      return this.$store.getters.tools_selectedTechnicalType;
    },

    objectTypeIsSelected() {
      return this.selectedObjectType === this.currentLayer.layer;
    },

    listIsOpen() {
      return this.openList === this.objectType;
    }
  },

  created() {
    this.setInitialSelectedLayer();
  },

  methods: {
    ...mapActions(["SET_TOOL_OBJECT_LAYER", "SET_TOOL_TECHNICAL_TYPE"]),

    setInitialSelectedLayer() {
      let defaultLayer = this.options.find(
        item => item.layer === this.defaultLayer
      );
      if (!defaultLayer.visible) {
        for (const layer of this.options) {
          if (layer.visible) {
            this.currentLayer = layer;
            return;
          }
        }
      }
      this.currentLayer = defaultLayer;
    },

    activateLayer(option) {
      this.toggleOptionsMenu(null);
      this.selectLayerOption(option);
      if (!this.objectTypeIsSelected) {
        this.selectItem(option);
      }
    },

    selectLayerOption(option) {
      this.currentLayer = option;
    },

    selectItem(option) {
      let previousLayer = this.selectedObjectLayer;
      let previousObjectType = this.selectedObjectType;
      let selectedLayer = option.layer;

      this.$emit("reset-selected-item");

      if (
        previousLayer !== selectedLayer ||
        previousObjectType !== selectedLayer
      ) {
        this.SET_TOOL_OBJECT_LAYER(selectedLayer);
        this.SET_TOOL_TECHNICAL_TYPE(selectedLayer);

        this.$emit("select-item", option);
      }
    },

    toggleOptionsMenu(objectType) {
      this.$emit("toggle-options-menu", objectType);
    }
  }
};
</script>

<style scoped>
.options-arrow {
  position: absolute !important;
  margin-left: 14px;
  bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/CreateObjects/ItemWithOptions.vue